import update from 'immutability-helper';
import { createSwitch, createCase } from 'helpers/action-helpers';
import { initialState } from './state';
import { SetMenuOperationAction, OpenMobileMenuAction, CloseMobileMenuAction } from './actions';
import { UserLoggedInAction, SetUserPermissionsAction } from 'pages/login/actions';
import { hasPermissionTo } from 'helpers/permission-helper';
import { Permission } from 'types/permission';
import { Mode } from 'types/mode';
import { nmvsMenuOperations } from 'types/nmvs-menu-item';

export const menuReducer = createSwitch(initialState, [
  createCase(new UserLoggedInAction(''), (state, action) => {
    const defaultOperationOnLogin = nmvsMenuOperations.verify;

    return update(state, {
      currentOperation: {
        $set: defaultOperationOnLogin
      }
    });
  }),
  createCase(new SetUserPermissionsAction(''), (state, action) => {
    if (state.currentOperation !== nmvsMenuOperations.verify &&
      !hasPermissionTo([Mode.Read], Permission.MarkAsDispense, action.permissions)) {
      return update(state, {
        currentOperation: {
          $set: nmvsMenuOperations.verify
        }
      });
    }

    return state;
  }),
  createCase(new SetMenuOperationAction(initialState.currentOperation), (state, action) => {
    return update(state, {
      currentOperation: { $set: action.menuOperation },
      mobileMenuVisible: { $set: false }
    });
  }),
  createCase(new OpenMobileMenuAction(), (state, action) => {
    return update(state, {
      mobileMenuVisible: { $set: true }
    });
  }),
  createCase(new CloseMobileMenuAction(), (state, action) => {
    return update(state, {
      mobileMenuVisible: { $set: false }
    });
  })
]);


// WEBPACK FOOTER //
// ./src/components/menu/reducer.ts